// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".light[data-v-65337bc0] {\n  color: gray;\n  font-weight: 300;\n}\n.wrapper-image-preview[data-v-65337bc0] {\n  text-align: center;\n  width: 420px;\n  min-height: 300px;\n  background-color: #efefef;\n}\n.image-preview[data-v-65337bc0] {\n  padding: 12px;\n  width: 420px;\n  min-height: 300px;\n  background-color: #eaeaea;\n}\n.image-preview[data-v-65337bc0],\ninput[type=file][data-v-65337bc0] {\n  width: 420px;\n  max-height: 300px;\n}", ""]);
// Exports
module.exports = exports;
